// extracted by mini-css-extract-plugin
export default {"taskbar":"Taskbar_taskbar__9LikN","left_cont":"Taskbar_left_cont__v3YHf","time":"Taskbar_time__12Y2R"};